import { useDispatch } from 'react-redux';
import { fetchContractConfig } from './contractConfig';
import { AppDispatch } from 'store';
import { fetchRewardDistributionData } from './rewardDistributionData';

export const useDispatchRawVestaMinter = () => {
  const dispatch = useDispatch<AppDispatch>();
  const dispatchAll = () => {
    dispatch(fetchContractConfig());
    dispatch(fetchRewardDistributionData());
  };

  return {
    dispatchAll
  };
};
